import React from 'react'
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import { connect } from "react-redux";
import { editTooltipData } from '../api/tooltipsapi';
import {  useNavigate } from 'react-router-dom';


const columns = [
    { id: 'id', label: 'Event ID' },
    { id: 'event_name', label: 'Description' },
];

const Tooltips = ({rowsPerPage,page,handleChangePage,handleChangeRowsPerPage,list}) => {

    const navigate = useNavigate();
    const handleRedirectEdit = (id) => {
        navigate('/web/tooltips/edit/'+id);
    }

    return (
        <Box>
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                <TableContainer>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                            <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ minWidth: column.minWidth }}
                            >
                                {column.label}
                            </TableCell>
                            ))}
                        </TableRow>
                        </TableHead>
                        <TableBody>
                        { list?.data?.records?.length > 0 ?  list?.data?.records.map((row,i) => {
                            return (
                                <TableRow sx={{cursor:'pointer'}} onClick={() => handleRedirectEdit(row.id)} hover role="checkbox" tabIndex={-1} key={i}>
                                {columns.map((column) => {
                                    const value = row[column.id];
                                    return (
                                    <TableCell key={column.id} align={column.align}>
                                        {column.format && typeof value === 'number'
                                        ? column.format(value)
                                        : value }
                                        
                                    </TableCell>
                                );
                                })}
                            </TableRow>
                            );
                        }): <TableRow><TableCell colSpan={3}>No Data Available. </TableCell></TableRow>}
                        </TableBody>
                    </Table>
                </TableContainer>
                { list?.data?.total > 0 ?  
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={list?.data?.total}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                : <></> }
            </Paper>
        </Box>
    )
}
const mapDispatchToProps = (dispatch) => ({
    loadEventInformation: (id)   => dispatch(editTooltipData(id)),  
});
    
export default connect(null, mapDispatchToProps)(Tooltips);
